var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "buyProduct-content" },
    [
      _c("div", { staticClass: "buyProduct" }, [
        _c("div", { staticClass: "basic-information-title" }, [
          _vm._v("购买产品")
        ]),
        _vm._v(" "),
        _c("div", [
          _vm.showCC == true && _vm.hasPRCreated
            ? _c("img", {
                staticClass: "newlyAddImg",
                staticStyle: { "margin-right": "0.2rem" },
                attrs: {
                  src: require("@/assets/img/scan_code.png"),
                  alt: "",
                  srcset: ""
                },
                on: {
                  click: function($event) {
                    return _vm.scanQR()
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showCC == true && _vm.hasPRCreated
            ? _c("img", {
                staticClass: "newlyAddImg",
                attrs: {
                  src: require("@/assets/img/newlyAdd.png"),
                  alt: "",
                  srcset: ""
                },
                on: {
                  click: function($event) {
                    return _vm.redact(1)
                  }
                }
              })
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _vm.list.length > 0
        ? _c(
            "div",
            { staticClass: "product-list" },
            _vm._l(_vm.list, function(item, index) {
              return _c(
                "div",
                { key: index },
                [
                  _c("div", { staticClass: "flex product-list-header" }, [
                    _c(
                      "div",
                      { staticClass: "flex center product-title-line" },
                      [
                        _c("div", { staticClass: "flex center" }, [
                          _c("img", {
                            staticClass: "camera",
                            attrs: {
                              src: require("@/assets/img/camera.png"),
                              alt: ""
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "product-name" }, [
                            _vm._v(
                              "\n                产品大类-" +
                                _vm._s(item.products1stType || "") +
                                "\n              "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.surveySubmitted[item.purchaseRecordId] ||
                        (_vm.availabeleSurvey[item.purchaseRecordId] &&
                          _vm.availabeleSurvey[item.purchaseRecordId].length >
                            0)
                          ? _c(
                              "div",
                              {
                                staticClass: "survey-button",
                                on: {
                                  click: function($event) {
                                    return _vm.surveyClicked(item)
                                  }
                                }
                              },
                              [
                                !_vm.surveySubmitted[item.purchaseRecordId]
                                  ? _c("span", [_vm._v("提交问卷")])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.surveySubmitted[item.purchaseRecordId]
                                  ? _c("span", [_vm._v("调查问卷")])
                                  : _vm._e()
                              ]
                            )
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _vm.salesId == item.createdId &&
                    _vm.showCC == true &&
                    _vm.hasPRModified
                      ? _c("img", {
                          staticClass: "redactImg",
                          attrs: {
                            src: require("@/assets/img/redact.png"),
                            alt: "",
                            srcset: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.redact(2, item.purchaseRecordId)
                            }
                          }
                        })
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c(
                    "van-popup",
                    {
                      attrs: {
                        "close-on-click-overlay": true,
                        position: "bottom"
                      },
                      model: {
                        value: _vm.showSelectSurvey,
                        callback: function($$v) {
                          _vm.showSelectSurvey = $$v
                        },
                        expression: "showSelectSurvey"
                      }
                    },
                    [
                      _c("van-picker", {
                        attrs: {
                          "show-toolbar": "",
                          columns: _vm.surveyColumn,
                          "value-key": "name"
                        },
                        on: {
                          cancel: _vm.onCancelSurverySelection,
                          confirm: _vm.onConfirmSurverySelection
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "product-list-content" }, [
                    _c(
                      "div",
                      {
                        staticClass: "basic-information-flex",
                        class: item.edit == true ? "active" : "activeno"
                      },
                      [
                        _c("div", { staticClass: "list-status" }, [
                          item.activatedState == 0 ||
                          item.activatedState == null
                            ? _c("p", [
                                _vm._v(
                                  "\n                未激活\n              "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          item.activatedState == 1
                            ? _c("p", [_vm._v("已激活")])
                            : _vm._e(),
                          _vm._v(" "),
                          item.activatedState == 2
                            ? _c("p", [_vm._v("人工驳回")])
                            : _vm._e(),
                          _vm._v(" "),
                          item.activatedState == 3
                            ? _c("p", [_vm._v("已退货")])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("ul", { staticClass: "basic-information-lists" }, [
                          _c("li", [
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-item" },
                              [_vm._v("购买日期")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-text" },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(item.buyDate) +
                                    "\n                "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-item" },
                              [_vm._v("门店")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-text" },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(item.deptName || "") +
                                    "\n                "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-item" },
                              [_vm._v("中文名称")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-text" },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(item.productNameCH || "") +
                                    "\n                "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-item" },
                              [_vm._v("销售金额")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-text" },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm
                                        .$numeral(item.amountAftTax)
                                        .format("0,0.00")
                                    ) +
                                    "\n                "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-item" },
                              [_vm._v("产品编号")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-text" },
                              [_vm._v(_vm._s(item.code))]
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-item" },
                              [_vm._v("产品大类")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-text" },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(item.products1stType) +
                                    "\n                "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-item" },
                              [_vm._v("产品分类")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-text" },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(item.products2ndType) +
                                    "\n                "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-item" },
                              [_vm._v("产品英文")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-text" },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(item.productNameEN) +
                                    "\n                "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-item" },
                              [_vm._v("序列号")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-text" },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(item.serial) +
                                    "\n                "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-item" },
                              [_vm._v("是否易手机")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-text" },
                              [
                                item.U_SecondProduct === "1"
                                  ? _c("span", [_vm._v("是")])
                                  : _c("span", [_vm._v("否")])
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _vm.isTvCode(item.code)
                            ? _c("div", [
                                _c("li", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "basic-information-lists-item"
                                    },
                                    [_vm._v("收货人姓名")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "basic-information-lists-text"
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(item.U_Consignee_Name) +
                                          "\n                  "
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "basic-information-lists-item"
                                    },
                                    [_vm._v("收货人手机号")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "basic-information-lists-text"
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(item.U_Consignee_Mobile) +
                                          "\n                  "
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "basic-information-lists-item"
                                    },
                                    [_vm._v("收货人地址")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "basic-information-lists-text"
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(item.U_Consignee_Address) +
                                          "\n                  "
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "basic-information-lists-item"
                                    },
                                    [_vm._v("快递单号")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "basic-information-lists-text"
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(item.U_Tracking_Number) +
                                          "\n                  "
                                      )
                                    ]
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("li", [
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-item" },
                              [_vm._v("激活日期")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-text" },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(item.activatedDate) +
                                    "\n                "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          item.activatedState == 3
                            ? _c("li", [
                                _c(
                                  "div",
                                  {
                                    staticClass: "basic-information-lists-item"
                                  },
                                  [_vm._v("退货原因")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "basic-information-lists-text"
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(item.returnReason) +
                                        "\n                "
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("li", [
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-item" },
                              [_vm._v("未激活原因")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-text" },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(item.reason) +
                                    "\n                "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-item" },
                              [_vm._v("优惠券")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-text" },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(item.couponType) +
                                    "\n                "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-item" },
                              [_vm._v("券号")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-text" },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(item.couponNo) +
                                    "\n                "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-item" },
                              [_vm._v("保修期")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-text" },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(item.defectsLiabilityPeriod || "") +
                                    "\n                "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-item" },
                              [_vm._v("注册会员产品")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-text" },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      item.lkfansProdSfid == null ? "否" : "是"
                                    ) +
                                    "\n                "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-item" },
                              [_vm._v("延保服务期")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-text" },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(item.extensionServicePeriod) +
                                    "\n                "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-item" },
                              [_vm._v("保修到期日")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "basic-information-lists-text" },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(item.warrantyExpirationDate) +
                                    "\n                "
                                )
                              ]
                            )
                          ])
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "flex packUp center",
                      on: {
                        click: function($event) {
                          return _vm.packUp(index)
                        }
                      }
                    },
                    [
                      item.edit == true
                        ? _c("img", {
                            staticClass: "arrow",
                            attrs: {
                              src: require("@/assets/img/upArrow1.png"),
                              alt: "",
                              srcset: ""
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      item.edit == false
                        ? _c("img", {
                            staticClass: "arrow",
                            attrs: {
                              src: require("@/assets/img/dowmArrow.png"),
                              alt: "",
                              srcset: ""
                            }
                          })
                        : _vm._e(),
                      _vm._v(
                        "\n          " +
                          _vm._s(item.edit == true ? "收起详情" : "展开详情") +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "product-model" },
        [
          _c(
            "van-popup",
            {
              attrs: { overlay: true, "close-on-click-overlay": false },
              model: {
                value: _vm.productShow,
                callback: function($$v) {
                  _vm.productShow = $$v
                },
                expression: "productShow"
              }
            },
            [
              _c("div", { staticClass: "model-height" }, [
                _c("div", { staticClass: "product-title" }, [
                  _vm._v(_vm._s(_vm.nameTitle) + "购买产品")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "basic-models-list" }, [
                  _c("div", { staticClass: "basic-models-list-item" }, [
                    _c("div", { staticClass: "models-list-item-title" }, [
                      _vm._v("购买日期")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "selectUp",
                        on: {
                          click: function($event) {
                            _vm.pullList[15]["name"] ? "" : _vm.timeSelections()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.pullList[12]["name"] || "请选择") +
                            "\n                "
                        ),
                        _c("img", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.pullList[15]["name"] == false,
                              expression: "pullList[15]['name'] == false"
                            }
                          ],
                          staticClass: "uparrow",
                          attrs: {
                            src: require("@/assets/img/uparrow.png"),
                            alt: "",
                            srcset: ""
                          }
                        })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "basic-models-list-item" }, [
                    _c("div", { staticClass: "models-list-item-title" }, [
                      _vm._v("产品货号")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.pullList[0]["name"],
                          expression: "pullList[0]['name']"
                        }
                      ],
                      attrs: {
                        type: "text",
                        oninput: "if(value.length>50)value=value.slice(0,50)",
                        disabled:
                          _vm.pullList[0]["editTallage"] != null ||
                          _vm.pullList[15]["name"],
                        placeholder: "请输入产品货号"
                      },
                      domProps: { value: _vm.pullList[0]["name"] },
                      on: {
                        blur: function($event) {
                          _vm.pullList[0]["name"] != ""
                            ? _vm.productCode(_vm.pullList[0]["name"])
                            : ""
                        },
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.productCode(_vm.pullList[0]["name"])
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.pullList[0], "name", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "basic-models-list-item" }, [
                    _c("div", { staticClass: "models-list-item-title" }, [
                      _vm._v("序列号")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.pullList[1]["name"],
                          expression: "pullList[1]['name']"
                        }
                      ],
                      attrs: {
                        type: "text",
                        placeholder: _vm.editS == true ? "请输入序号" : "",
                        disabled:
                          _vm.pullList[1]["editTallage"] != null ||
                          _vm.pullList[15]["name"],
                        oninput: "if(value.length>50)value=value.slice(0,50)"
                      },
                      domProps: { value: _vm.pullList[1]["name"] },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.pullList[1], "name", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "basic-models-list-item" }, [
                    _c("div", { staticClass: "models-list-item-title" }, [
                      _vm._v("产品大类")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "selectUp",
                        on: {
                          click: function($event) {
                            _vm.pullList[2]["editTallage"] != null
                              ? ""
                              : _vm.pullList[15]["name"]
                              ? ""
                              : _vm.downSelections(2)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.pullList[2]["name"] || "请选择") +
                            "\n                "
                        ),
                        _c("img", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.pullList[15]["name"] == false,
                              expression: "pullList[15]['name'] == false"
                            }
                          ],
                          staticClass: "uparrow",
                          attrs: {
                            src: require("@/assets/img/uparrow.png"),
                            alt: "",
                            srcset: ""
                          }
                        })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "basic-models-list-item" }, [
                    _c("div", { staticClass: "models-list-item-title" }, [
                      _vm._v("产品分类")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "selectUp",
                        on: {
                          click: function($event) {
                            _vm.pullList[3]["editTallage"] != null
                              ? ""
                              : _vm.pullList[15]["name"]
                              ? ""
                              : _vm.downSelections(3)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.pullList[3]["name"] || "请选择") +
                            "\n                "
                        ),
                        _c("img", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.pullList[15]["name"] == false,
                              expression: "pullList[15]['name'] == false"
                            }
                          ],
                          staticClass: "uparrow",
                          attrs: {
                            src: require("@/assets/img/uparrow.png"),
                            alt: "",
                            srcset: ""
                          }
                        })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "basic-models-list-item" }, [
                    _c("div", { staticClass: "models-list-item-title" }, [
                      _vm._v("产品中文名")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.pullList[4]["name"],
                          expression: "pullList[4]['name']"
                        }
                      ],
                      attrs: {
                        type: "text",
                        oninput: "if(value.length>50)value=value.slice(0,50)",
                        disabled:
                          _vm.pullList[4]["editTallage"] != null ||
                          _vm.pullList[15]["name"],
                        placeholder: "请输入产品中文名"
                      },
                      domProps: { value: _vm.pullList[4]["name"] },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.pullList[4], "name", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "basic-models-list-item" }, [
                    _c("div", { staticClass: "models-list-item-title" }, [
                      _vm._v("产品英文名")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.pullList[5]["name"],
                          expression: "pullList[5]['name']"
                        }
                      ],
                      attrs: {
                        type: "text",
                        oninput: "if(value.length>50)value=value.slice(0,50)",
                        disabled:
                          _vm.pullList[5]["editTallage"] != null ||
                          _vm.pullList[15]["name"],
                        placeholder: "请输入产品英文名"
                      },
                      domProps: { value: _vm.pullList[5]["name"] },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.pullList[5], "name", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "basic-models-list-item" }, [
                    _c("div", { staticClass: "models-list-item-title" }, [
                      _vm._v("建议零售价")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.pullList[13]["name"],
                          expression: "pullList[13]['name']"
                        }
                      ],
                      attrs: { type: "number", disabled: "disabled" },
                      domProps: { value: _vm.pullList[13]["name"] },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.pullList[13],
                            "name",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "basic-models-list-item" }, [
                    _c("div", { staticClass: "models-list-item-title" }, [
                      _vm._v("销售金额")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.pullList[6]["name"],
                          expression: "pullList[6]['name']"
                        }
                      ],
                      attrs: {
                        type: "number",
                        oninput: "if(value.length>50)value=value.slice(0,50)",
                        placeholder: "请输入销售金额",
                        disabled: _vm.pullList[15]["name"]
                      },
                      domProps: { value: _vm.pullList[6]["name"] },
                      on: {
                        blur: _vm.ratesCount,
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.pullList[6], "name", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "basic-models-list-item" }, [
                    _c("div", { staticClass: "models-list-item-title" }, [
                      _vm._v("是否易手机")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "second-product" },
                      [
                        _c("van-switch", {
                          attrs: { "active-color": "#ff4040", size: "18px" },
                          model: {
                            value: _vm.pullList[16]["val"],
                            callback: function($$v) {
                              _vm.$set(_vm.pullList[16], "val", $$v)
                            },
                            expression: "pullList[16]['val']"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: false,
                          expression: "false"
                        }
                      ],
                      staticClass: "basic-models-list-item"
                    },
                    [
                      _c("div", { staticClass: "models-list-item-title" }, [
                        _vm._v("未税金额")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.pullList[7]["name"],
                            expression: "pullList[7]['name']"
                          }
                        ],
                        attrs: {
                          type: "number",
                          disabled: _vm.editTallage,
                          oninput: "if(value.length>50)value=value.slice(0,50)",
                          placeholder: "请输入未税金额"
                        },
                        domProps: { value: _vm.pullList[7]["name"] },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.pullList[7],
                              "name",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "basic-models-list-item" }, [
                    _c("div", { staticClass: "models-list-item-title" }, [
                      _vm._v("社媒平台引流")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "selectUp",
                        on: {
                          click: function($event) {
                            _vm.pullList[15]["name"]
                              ? ""
                              : _vm.downSelections(21)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.pullList[21]["name"] || "请选择") +
                            "\n                "
                        ),
                        _c("img", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.pullList[15]["name"] == false,
                              expression: "pullList[15]['name'] == false"
                            }
                          ],
                          staticClass: "uparrow",
                          attrs: {
                            src: require("@/assets/img/uparrow.png"),
                            alt: "",
                            srcset: ""
                          }
                        })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "basic-models-list-item",
                      staticStyle: { height: "1.5rem" }
                    },
                    [
                      _c("div", { staticClass: "models-list-item-title" }, [
                        _vm._v("上传购买凭证")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "van-uploader__preview" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "van-image van-uploader__preview-image",
                            on: {
                              click: function($event) {
                                _vm.pullList[15]["name"]
                                  ? ""
                                  : _vm.selectImage()
                              }
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "van-image__img",
                              staticStyle: { "object-fit": "cover" },
                              attrs: { src: _vm.uploadCertificate }
                            })
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.showTvFiled
                    ? _c("div", { staticClass: "basic-models-list-item" }, [
                        _c("div", { staticClass: "models-list-item-title" }, [
                          _vm._v("收货人姓名")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.pullList[17]["name"],
                              expression: "pullList[17]['name']"
                            }
                          ],
                          attrs: {
                            type: "text",
                            placeholder: "请输入收货人姓名"
                          },
                          domProps: { value: _vm.pullList[17]["name"] },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.pullList[17],
                                "name",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showTvFiled
                    ? _c("div", { staticClass: "basic-models-list-item" }, [
                        _c("div", { staticClass: "models-list-item-title" }, [
                          _vm._v("收货人手机")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.pullList[18]["name"],
                              expression: "pullList[18]['name']"
                            }
                          ],
                          attrs: {
                            type: "number",
                            placeholder: "请输入收货人手机"
                          },
                          domProps: { value: _vm.pullList[18]["name"] },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.pullList[18],
                                "name",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showTvFiled
                    ? _c("div", { staticClass: "basic-models-list-item" }, [
                        _c("div", { staticClass: "models-list-item-title" }, [
                          _vm._v("收货人地址")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.pullList[19]["name"],
                              expression: "pullList[19]['name']"
                            }
                          ],
                          attrs: {
                            type: "text",
                            placeholder: "请输入收货人地址"
                          },
                          domProps: { value: _vm.pullList[19]["name"] },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.pullList[19],
                                "name",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "basic-models-list-item",
                      on: {
                        click: function($event) {
                          _vm.pullList[15]["name"] ? "" : _vm.downSelections(8)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "models-list-item-title" }, [
                        _vm._v("优惠劵")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "selectUp" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.pullList[8]["name"] || "请选择") +
                            "\n                "
                        ),
                        _vm._v(" "),
                        _c("img", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.pullList[15]["name"] == false,
                              expression: "pullList[15]['name'] == false"
                            }
                          ],
                          staticClass: "uparrow",
                          attrs: {
                            src: require("@/assets/img/uparrow.png"),
                            alt: "",
                            srcset: ""
                          }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "basic-models-list-item" }, [
                    _c("div", { staticClass: "models-list-item-title" }, [
                      _vm._v("未激活原因")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.pullList[14]["name"],
                          expression: "pullList[14]['name']"
                        }
                      ],
                      attrs: {
                        type: "text",
                        disabled: "disabled",
                        placeholder: "暂无"
                      },
                      domProps: { value: _vm.pullList[14]["name"] },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.pullList[14],
                            "name",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "basic-models-list-item" }, [
                    _c("div", { staticClass: "models-list-item-title" }, [
                      _vm._v("劵号")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.pullList[9]["name"],
                          expression: "pullList[9]['name']"
                        }
                      ],
                      attrs: {
                        type: "text",
                        maxlength: "50",
                        placeholder: "请输入劵号",
                        disabled: _vm.pullList[15]["name"]
                      },
                      domProps: { value: _vm.pullList[9]["name"] },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.pullList[9], "name", $event.target.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "uparrow",
                      attrs: {
                        src: require("@/assets/img/scan_code.png"),
                        alt: "",
                        srcset: ""
                      },
                      on: {
                        click: function($event) {
                          return _vm.scanCoupon()
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "basic-models-list-item" }, [
                    _c("div", { staticClass: "models-list-item-title" }, [
                      _vm._v("购买门店")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "selectUp",
                        on: {
                          click: function($event) {
                            _vm.pullList[15]["name"]
                              ? ""
                              : _vm.downSelections(10)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.pullList[10]["name"] || "请选择") +
                            "\n                "
                        ),
                        _c("img", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.pullList[15]["name"] == false,
                              expression: "pullList[15]['name'] == false"
                            }
                          ],
                          staticClass: "uparrow",
                          attrs: {
                            src: require("@/assets/img/uparrow.png"),
                            alt: "",
                            srcset: ""
                          }
                        })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "basic-models-list-item" }, [
                    _c("div", { staticClass: "models-list-item-title" }, [
                      _vm._v("销售顾问")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "selectUp",
                        on: {
                          click: function($event) {
                            _vm.pullList[10]["val"]
                              ? _vm.pullList[15]["name"]
                                ? ""
                                : _vm.downSelections(11)
                              : ""
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.pullList[11]["name"] || "请选择") +
                            "\n                "
                        ),
                        _c("img", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.pullList[15]["name"] == false,
                              expression: "pullList[15]['name'] == false"
                            }
                          ],
                          staticClass: "uparrow",
                          attrs: {
                            src: require("@/assets/img/uparrow.png"),
                            alt: "",
                            srcset: ""
                          }
                        })
                      ]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "confirm-cancel" }, [
                _c(
                  "div",
                  { staticClass: "button-flex-color flex-border-button" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "button-flex-item",
                        on: { click: _vm.cancelProduct }
                      },
                      [_vm._v("取消")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "button-flex-color" }, [
                  _c(
                    "div",
                    {
                      staticClass: "button-flex-item",
                      class: {
                        "button-active": _vm.pullList[15]["name"] == false,
                        "button-disabled": _vm.pullList[15]["name"]
                      },
                      on: {
                        click: function($event) {
                          _vm.pullList[15]["name"] ? "" : _vm.confirmProduct()
                        }
                      }
                    },
                    [_vm._v("\n              确定\n            ")]
                  )
                ])
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom", overlay: true },
          model: {
            value: _vm.showDownSelection,
            callback: function($$v) {
              _vm.showDownSelection = $$v
            },
            expression: "showDownSelection"
          }
        },
        [
          _c("van-picker", {
            staticClass: "van-picker-li",
            attrs: {
              "show-toolbar": "",
              title: "",
              columns: _vm.downSelection,
              "value-key": "name" || "deptName"
            },
            on: { cancel: _vm.onCancelCode, confirm: _vm.onConfirmCode }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticStyle: { width: "100%" },
          attrs: { position: "bottom", overlay: true },
          model: {
            value: _vm.timeShow,
            callback: function($$v) {
              _vm.timeShow = $$v
            },
            expression: "timeShow"
          }
        },
        [
          _c("van-datetime-picker", {
            attrs: {
              type: "date",
              "max-date": _vm.maxDate,
              "min-date": _vm.minDate
            },
            on: { confirm: _vm.timeConfirm, cancel: _vm.timeCancel },
            model: {
              value: _vm.currentDate,
              callback: function($$v) {
                _vm.currentDate = $$v
              },
              expression: "currentDate"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "product-model-min" },
        [
          _c(
            "van-popup",
            {
              model: {
                value: _vm.submitShow,
                callback: function($$v) {
                  _vm.submitShow = $$v
                },
                expression: "submitShow"
              }
            },
            [
              _c("div", { staticClass: "model-height" }, [
                _c("div", { staticClass: "product-title" }, [
                  _vm._v("激活保卡信息上传成功")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "confirm-cancel" }, [
                _c("div", { staticClass: "button-flex-color" }, [
                  _c(
                    "div",
                    {
                      staticClass: "button-flex-item button-active",
                      on: { click: _vm.submitShowf }
                    },
                    [_vm._v("\n              确定\n            ")]
                  )
                ])
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62bfb450", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62bfb450","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/childCompoents/buyProduct.vue
// module id = null
// module chunks = 